import React from 'react'

function Error() {
  return (
<div className="w-full flex justify-center items-center">
    <h1 className="font-bold capitalize text-2xl text-white">Error: Your Search Didn't Bring Any Results</h1>
  </div>  )
}

export default Error